// extracted by mini-css-extract-plugin
export default {"clientMenuContainer":"ClientMenuIconStyles_clientMenuContainer__OSfz2","clientMenuIcon":"ClientMenuIconStyles_clientMenuIcon__K+IxN"};